/* eslint-env browser */
/* global webkitSpeechRecognition, webkitSpeechGrammarList */
// var SpeechRecognitionEvent = window.SpeechRecognitionEvent || webkitSpeechRecognitionEvent;

declare global {
       //@ts-ignore
        const webkitSpeechRecognition: SpeechRecognition;
         //@ts-ignore
        const webkitSpeechGrammarList: SpeechGrammarList;
}

export interface SpeechRecognitionOptions { 
    language: string, 
    continuous: boolean,
    isFirstTime: boolean
}

export function startSpeechRecognition(vm: Vue, {language, continuous, isFirstTime}: SpeechRecognitionOptions) {
    try {
         //@ts-ignore
        let SpeechRecognitionCrossBrowser = (webkitSpeechRecognition || SpeechRecognition) as any;
         //@ts-ignore
        let SpeechGrammarListCrossBrowser = (webkitSpeechGrammarList || SpeechGrammarList) as any;
        if (SpeechRecognitionCrossBrowser && SpeechGrammarListCrossBrowser) {
            let forceStopRecognition = false;
            let phrase = "";
            let grammar = '#JSGF V1.0; grammar phrase; public <phrase> = ' + phrase + ';';
             //@ts-ignore
            let recognition: SpeechRecognition = new SpeechRecognitionCrossBrowser();
             //@ts-ignore
            let speechRecognitionList: SpeechGrammarList = new SpeechGrammarListCrossBrowser();
            speechRecognitionList.addFromString(grammar, 1);
            recognition.grammars = speechRecognitionList;
            recognition.lang = language || 'en-US';
            recognition.interimResults = false;

            if (continuous) {

                recognition.continuous = true;
            }
            recognition.maxAlternatives = 1;

            recognition.start();

            recognition.onresult = function (event) {
                // The SpeechRecognitionEvent results property returns a SpeechRecognitionResultList object
                // The SpeechRecognitionResultList object contains SpeechRecognitionResult objects.
                // It has a getter so it can be accessed like an array
                // The first [0] returns the SpeechRecognitionResult at position 0.
                // Each SpeechRecognitionResult object contains SpeechRecognitionAlternative objects that contain individual results.
                // These also have getters so they can be accessed like arrays.
                // The second [0] returns the SpeechRecognitionAlternative at position 0.
                // We then return the transcript property of the SpeechRecognitionAlternative object 
                let result = event.results.length - 1;
                let speechResult = event.results[result][0].transcript.toLowerCase();
                if (vm) {
                    vm.$emit('utterance', speechResult);
                }
                if (continuous) {
                    recognition.stop();
                }
                console.log('Confidence: ' + event.results[0][0].confidence);
            };

            recognition.onspeechend = function () {
                console.log('SpeechRecognition.onspeechend');

            };

            recognition.onerror = function (event: Event) {
                const errorEvent = event as ErrorEvent;
                console.log('SpeechRecognition.onerror', errorEvent.error);
            
                if (vm) {
                    vm.$emit('error', errorEvent.error);
                }
            };

            recognition.onaudiostart = function (_event) {
                //Fired when the user agent has started to capture audio.
                console.log('SpeechRecognition.onaudiostart');
            };

            recognition.onaudioend = function (_event) {
                //Fired when the user agent has finished capturing audio.
                console.log('SpeechRecognition.onaudioend');
            };

            recognition.onend = function (_event) {
                //Fired when the speech recognition service has disconnected.
                console.log('SpeechRecognition.onend', _event);
                if (vm && !forceStopRecognition) {
                    vm.$emit('end', "Loading...");
                }
                forceStopRecognition = false;



            };

            recognition.onnomatch = function (_event) {
                //Fired when the speech recognition service returns a final result with no significant recognition. This may involve some degree of recognition, which doesn't meet or exceed the confidence threshold.
                console.log('SpeechRecognition.onnomatch');
            };

            recognition.onsoundstart = function (_event) {
                //Fired when any sound — recognisable speech or not — has been detected.
                console.log('SpeechRecognition.onsoundstart');
            };

            recognition.onsoundend = function (_event) {
                //Fired when any sound — recognisable speech or not — has stopped being detected.
                console.log('SpeechRecognition.onsoundend');
            };

            recognition.onspeechstart = function (_event) {
                //Fired when sound that is recognised by the speech recognition service as speech has been detected.
                console.log('SpeechRecognition.onspeechstart');


            };
            recognition.onstart = function (_event) {
                //Fired when the speech recognition service has begun listening to incoming audio with intent to recognize grammars associated with the current SpeechRecognition.
                console.log('SpeechRecognition.onstart');
                if (vm) {
                    vm.$emit('start', "Listening...");
                }


            };
            if (vm && isFirstTime) {
                //  need to check this code 
                vm.$on('stoprecognition', () => {
                    //if (continuous) {
                    // need to check this
                    console.log("forceStopRecognition");
                    forceStopRecognition = true;
                    recognition.stop();
                    // }

                });
            }
        }
       
    }
    catch (err) {
        console.error("in catch >> ", err);
    }
}

